import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Tabs } from 'antd';
import PropTypes from 'prop-types';
import Helpers from '@Apis/helpers';
import ResourcesList from './Resources/ResourcesList';
import TemplateRouteList from './TemplateRoutes/TemplateRoutesList';
import './style.scss';

const { TabPane } = Tabs;

/**
 *
 */
class Configurations extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      showAddProductModal: false,
      currentTab: '/machines',
    };
  }

  /**
   *
   * @param {*} props
   * @param {*} state
   * @return
   */
  static getDerivedStateFromProps(props, state) {
    const { location } = props;
    const key = new URLSearchParams(location.search).get('tab');
    return {
      ...state,
      currentTab: key || '/machines',
    };
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const { currentTab } = this.state;
    const { history, user } = this.props;
    return (
      <Fragment>
        <div>
          <div className="doc-list__tabs-wrapper">
            <Tabs
              activeKey={currentTab}
              onChange={(key) => {
                this.setState({ currentTab: key });
                history.push(`?tab=${key}`);
              }}
              mode="horizontal"
            >
              <TabPane tab="Machines" key="/machines" />
              {user?.tenant_info?.production_config?.sub_modules?.bill_of_material?.is_active && Helpers.getPermission(Helpers.permissionEntities.FACTORY_SETUP,
                Helpers.permissionTypes.READ, user) && (
                  <TabPane tab="Production Processes" key="/production-processes" />
                )}
            </Tabs>
            {currentTab === '/machines' && (
              <ResourcesList />
            )}
            {currentTab === '/production-processes' && (
              <TemplateRouteList />
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,
});

const mapDispatchToProps = () => ({
});

Configurations.propTypes = {
  location: PropTypes.func,
  history: PropTypes.func,
  user: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Configurations));
